import { Button, Col, Spinner } from 'react-bootstrap';
import TextInput from 'components/input/textInput';
import Grid from '@mui/joy/Grid';

interface Props {
  formik: any;
  check?: any;
  saving: boolean;
  handleInvite: () => void;
  isMobile?: boolean;
  disabled?: boolean;
}

const CounselorInformation = (props: Props) => {
  const { formik, check, saving, handleInvite, isMobile = false, disabled = false } = props;
  return (
    <Grid container spacing={2} className="gm-form-fields">
      <Grid xs={12}>
        <div className="fs-5 p-1">High School Counselor Information</div>
      </Grid>

      <Grid xs={12} md={6}>
        <TextInput
          countText={60}
          className="coallition-flag"
          name="counselor_first_name"
          onChange={props.formik.handleChange}
          values={props.formik.values.counselor_first_name}
          label="Counselor's First Name*"
          isMissing={!props.formik.values.counselor_first_name && check}
          disabled={disabled}
        />
      </Grid>
      
      <Grid xs={12} md={6}>
        <TextInput
          countText={60}
          className="coallition-flag end-flag"
          name="counselor_last_name"
          onChange={props.formik.handleChange}
          values={props.formik.values.counselor_last_name}
          label="Counselor's Last Name*"
          isMissing={!props.formik.values.counselor_last_name && check}
          disabled={disabled}
        />
      </Grid>
      
      <Grid xs={12}>
        <TextInput
          name="counselor_email"
          countText={80}
          className="coallition-flag"
          onChange={props.formik.handleChange}
          values={props.formik.values.counselor_email}
          label="Counselor's Email"
          disabled={disabled}
        />
        <div className="row">
          <div className="col-md-12">
            <div
              className="p-0 p-md-1 d-md-flex justify-content-end"
              style={{ paddingLeft: 0 }}
            >
              <Button
                disabled={saving || disabled}
                variant="primary"
                onClick={async () => handleInvite()}
                className="btn-update"
                style={{width:'230px'}}
              >
                Invite Counselor to Collaborate
              </Button>
            </div>
          </div>
        </div>
      </Grid>

    </Grid>
  );
};

export default CounselorInformation;
